import React from "react";
import "./Heading.scss"; // Importing CSS file for Heading styles

const Heading = ({ level, children, className, id }) => {
  // Ensure level is between 1 and 6, otherwise default to 1
  const HeadingTag = `h${level >= 1 && level <= 6 ? level : 1}`;

  return React.createElement(HeadingTag, { className, id }, children);
};

export default Heading;
